import React from 'react';
import { FormControl, FormLabel, TextField, Typography } from '@mui/material';

export const Input = ({
	disabled,
	error,
	name,
	label,
	required,
	value,
	onChange,
	'data-cy': dataCy,
	multiline = false,
	rows = undefined,
	type = 'text',
}) => {
	return (
		<>
			<FormControl fullWidth data-cy={dataCy}>
				<FormLabel id={`${name}-label`}>{label}</FormLabel>
				<TextField
					size="small"
					aria-labelledby={`${name}-label`}
					type={type}
					multiline={multiline}
					rows={rows}
					value={value}
					error={error}
					required={required}
					disabled={Boolean(disabled)}
					name={name}
					onChange={(event) => onChange(event.target.value)}
				/>
			</FormControl>
			<Typography color="error">{error || <br />}</Typography>
		</>
	);
};
